// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"65e955d8","404":"97f469dd","498":"543bf0dc","787":"f22b8f29"}[chunkId] + ".chunk.js";
};